const config = {
  // Used to decide what we are publishing in production vs beta
  GATSBY_TARGET_ENV: process.env.GATSBY_TARGET_ENV,
  AITO_APP_HOST_NAME: 'aito.app'
}

// Needs to be in CommonJS so it can be used in gatsby-node.js and other code
module.exports = config
